import { render, staticRenderFns } from "./AtelierBiennale2021Page.vue?vue&type=template&id=6affd3b1"
import script from "./AtelierBiennale2021Page.vue?vue&type=script&lang=js"
export * from "./AtelierBiennale2021Page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports